import { WeatherStationObservationDataKey } from 'features/weatherStations/weatherStations.types';
import { ReactNode } from 'react';
import NavigationIcon from '@mui/icons-material/Navigation';
import WindGustIcon from 'assets/wind_gust.svg?react';
import { convertCelsiusToFahrenheit } from 'features/weatherStations/utils/convertCelsiusToFahrenheit';
import { parseNumericValue } from 'features/weatherStations/utils/parseNumericValue';
import { convertMetersPerSecToMph } from 'features/weatherStations/utils/convertMetersPerSecToMph';
import { EMPTY_DATA_VALUE } from 'features/weatherStations/weatherStations.constants';

export const OBSERVATION_SENSOR_TYPE_TO_LABEL: Record<
  WeatherStationObservationDataKey,
  ReactNode
> = {
  airTemp: '˚F',
  dewPointTemperature: 'DEW',
  relativeHumidity: 'HUM',
  windDirectionToward: (
    <NavigationIcon sx={{ fontSize: 12, rotate: '45deg' }} />
  ),
  windSpeed: 'MPH',
  windGust: <WindGustIcon style={{ width: 15, height: 'auto' }} />,
};

export const OBSERVATIONS_DATA_PARSERS: Record<
  string,
  (value?: number) => ReactNode
> = {
  airTemp: (val?: number) =>
    val ? `${convertCelsiusToFahrenheit(val, 0)}˚` : EMPTY_DATA_VALUE,
  dewPointTemperature: (val?: number) =>
    val ? `${convertCelsiusToFahrenheit(val, 0)}˚` : EMPTY_DATA_VALUE,
  relativeHumidity: (val?: number) =>
    val ? `${parseNumericValue(val, 0)}` : EMPTY_DATA_VALUE,
  windDirectionToward: (val?: number) =>
    val ? (
      <NavigationIcon
        sx={{
          fontSize: 12,
          rotate: `${parseNumericValue(val, 0)}deg`,
        }}
      />
    ) : (
      EMPTY_DATA_VALUE
    ),
  windSpeed: (val?: number) =>
    val ? convertMetersPerSecToMph(val, 0) : EMPTY_DATA_VALUE,
  windGust: (val?: number) =>
    val ? convertMetersPerSecToMph(val, 0) : EMPTY_DATA_VALUE,
};
